import { ReactElement } from 'react';
import CurrencyPrice from '../../../../../../common/currency-price/currency-price';
import MaterialLink from '../../../../../../common/material-link/material-link';
import CartDownloadBtn from '../../../../../../common/material/components/cart-download-btn/cart-download-btn';
import PriceBlock from '../../../../../../common/material/components/price-block';
import usePrices from '../../../../../../common/material/material-long/desktop-parts/right-part/hooks/use-prices';
import { FavoritesMaterialCardProps } from '../../types';
import AddToFolderIconButton from '../add-to-folder-icon-button/add-to-folder-icon-button';
import MaterialRemoveButton from '../material-remove-button/material-remove-button';
import './material-unacquired-info.scss';

type MaterialUnacquiredInfoProps = {
    item: FavoritesMaterialCardProps['item'];
    index: FavoritesMaterialCardProps['index'];
    internalPath?: FavoritesMaterialCardProps['internalPath'];
    showAddToCart?: boolean;
    onAddToCartSuccess?: (props: { cart: Cart; idsOfMaterialsIncludedInBundle: number[] }) => void;
    onAddToCartError?: VoidFunction;
    onAddToCartCallback?: (material: Material) => boolean;
    isAddToCartButtonDisabled?: boolean;
    addToCartButtonClassNames?: string;
    addToCartType?: 'icon' | 'button';
    shouldShowFolder?: boolean;
    removeButtonType?: 'icon' | 'removeOnly';
};

const MaterialUnacquiredInfo = (props: MaterialUnacquiredInfoProps): ReactElement => {
    const { item, internalPath, shouldShowFolder, index, removeButtonType, ...rest } = props;

    const { originalPrice } = usePrices({ item });

    const hasDiscount = Boolean(originalPrice);

    const cartBtnType = rest.addToCartType === 'icon' ? ('icon' as const) : ('button' as const);
    const cartBtnClassNames = { wrapperClassName: 'favorites-unacquired-info-cart-btn' };
    const cartBtnProps = {
        type: cartBtnType,
        hideRestrictionsMessage: true,
        ...rest,
        ...cartBtnClassNames
    };

    return (
        <>
            <MaterialLink omitForBots className='link-inherit prices' item={item} internalPath={internalPath} title={item.title}>
                <PriceBlock className='tsc-subheadline' item={item} />
                {hasDiscount && (
                    <span className='strike-through before-sale-price'>
                        <CurrencyPrice price={originalPrice} />
                    </span>
                )}
            </MaterialLink>

            <CartDownloadBtn item={item} {...cartBtnProps} />

            {shouldShowFolder && <AddToFolderIconButton item={item} />}

            {removeButtonType && <MaterialRemoveButton item={item} index={index} type={removeButtonType} />}
        </>
    );
};

export default MaterialUnacquiredInfo;
